/**
 * Created by Kristy on 19/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsReport', {
                parent: 'adminIndex',
                url: '/hospitalizations/report',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/hospitalizationsReport/hospitalizationsReport.html',
                        controller: 'HospitalizationsReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
